module.exports = __webpack_public_path__ + "static/floating-action-button-icon-only-dont-7f465b872a970d505b5f19e24e4ba76f.png";